import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useIncomeStatement(id, period) {
  const { data, error, isLoading } = useSWRImmutable(`/react/income_statements?stock_id=${id}&period=${period}`, fetcher)

  return {
    incomeStatement: data,
    isLoading,
    error
  }
}